import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { CoreComponentService } from '@app/core/services/core-component.service';
import { ComponentBaseComponent } from '../component-base/component-base.component';

@Component({
    selector: 'tt-field-group',
    templateUrl: './field-group.component.html',
    styleUrls: ['./field-group.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class FieldGroupComponent extends ComponentBaseComponent {}
